import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import DividendsPopUp from './dividendsPopUp';

export default function ApexChart({ top5Dividends }) {
  console.log("🚀 ~ ApexChart ~ top5Dividends:", top5Dividends)
  const [series] = useState([{
    data: top5Dividends?.serise ? top5Dividends.serise.map(value => Number(value)) : []
  }]);
  const [showPopUp, setShowPopUp] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const labels = top5Dividends?.options || [];

  const [options] = useState({
    chart: {
      type: 'bar',
      toolbar: {
        show: false // Hide the toolbar
      }
    },
    plotOptions: {
      bar: {
        horizontal: true, // Set to true for horizontal bars
        distributed: true, // Allows each bar to have a separate color
        // barHeight: '25px',
      }
    },
    xaxis: {
      // categories: ['FIRST MILLING CO ', 'ADNOC GAS PLC', 'SAL SAUDI LOGISTICS', 'DUBAI ELECTRICITY AND WATER AU', 'ADNOC LOGISTICS AND SERVICES'],
      categories: labels,
      labels: {
        show: false // Hide x-axis labels
      },
      title: {
        text: undefined // Hide x-axis title
      }
    },
    yaxis: {
      labels: {
        show: false // Hide y-axis labels
      },
      title: {
        text: undefined // Hide y-axis title
      }
    },
    colors: ['#1d3b6f', '#a4906b', '#4a4c55', '#63366e', '#a9333a', '#006b68', '#006394', '#6f7197', '#c3b59b', '#828189', '#bf8486', '#bf8486', '#769a98', '#6d94b5'],
    legend: {
      position: 'bottom',
      horizontalAlign: 'left',
      fontSize: '12px',
      fontFamily: "Montserrat SemiBold",
      color: "#000"
    },
    tooltip: {
      enabled: false, // Disable tooltips
    },
    responsive: [{
      breakpoint: 992,
      options: {
        chart: {
          // width: "100%"
          height: "400px"
        },
        legend: {
          position: 'bottom'
        }
      },
      plotOptions: {
        bar: {
          barHeight: '100%',
        }
      },
    }]
  });

  return (
    <div>
      <div id="chart">
        <ReactApexChart options={options} series={series} type="bar" />
      </div>
      {/* {showPopUp && (
        <DividendsPopUp
          data={selectedData}
          onClose={() => setShowPopUp(false)} // Close the pop-up when user clicks outside or on a close button
        />
      )} */}
      <div id="html-dist"></div>
    </div>
  );
}
